// Module
var code = "<abx-building-header class=\"elevation-frame-4dp\" building=\"vm.building\" abx-title=\"vm.title\" subtitle=\"vm.subtitle\" actions=\"vm.actions\"> </abx-building-header> <abx-job-list abx-building=\"vm.building\" abx-models=\"vm.jobs\" abx-fetch=\"vm.fetchJobs(skip, limit)\" abx-permissions=\"vm.permissions\"> </abx-job-list> ";
// Exports
module.exports = code;